"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SORTING_TYPES = exports.DEFAULT_COLUMN_WIDTH = exports.HEADER_HEIGHT = exports.MIN_ROW_WIDTH = exports.ROW_HEIGHT = void 0;
exports.ROW_HEIGHT = 36;
exports.MIN_ROW_WIDTH = 75;
exports.HEADER_HEIGHT = 40;
exports.DEFAULT_COLUMN_WIDTH = 60;
exports.SORTING_TYPES = {
    toggleSort: 'toggle-sort',
    threeStateSort: 'three-state-sort'
};
